module.exports = __webpack_public_path__ + "static/media/rurki.ef82437b.jpg";